// src/components/OfflineMarketingBanner.js
import React from 'react';
import './OfflineMarketingBanner.css'; // Reuse the same CSS

const OfflineMarketingBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Event Activities</h2>
      </div>
    </div>
  );
};

export default OfflineMarketingBanner;
